

export const onBasicPlanCreate = (values) => {

    const errors = {}
     if (required(values.plan_name)) {
        errors.plan_name = 'Plan name is required'
    } 
    if (required(values.plan_amount)) {
        errors.plan_amount = 'Plan amount required'
    }
    if (required(values.video_amount)) {
        errors.video_amount = 'Video amount required'
    }

    if (required(values.video_count)) {
        errors.video_count = 'Video count required'
    }

    if (required(values.status )) {
        errors.status  = 'Status required'
    }
    if (required(values.public_video_amount)) {
        errors.public_video_amount = 'Public video amount required'
    }

    if (required(values.public_video_count)) {
        errors.public_video_count = 'Public video count required'
    }

    return errors;
   
};

export const onBasicPlanEdit = (values) => {

    const errors = {}
    if (required(values.plan_name)) {
        errors.plan_name = 'Plan name is required'
    } 
    if (required(values.plan_amount)) {
        errors.plan_amount = 'Plan amount required'
    }
    if (required(values.video_amount)) {
        errors.video_amount = 'Video amount required'
    }

    if (required(values.video_count)) {
        errors.video_count = 'Video count required'
    }

    if (required(values.status )) {
        errors.status  = 'Status required'
    }
    if (required(values.public_video_amount)) {
        errors.public_video_amount = 'Public video amount required'
    }

    if (required(values.public_video_count)) {
        errors.public_video_count = 'Public video count required'
    }
    return errors;
   
};

















const isEmpty = (value: any) =>{
    return (typeof value === 'undefined' || value === null || value === '')
}

export const required = (value) =>{
    return isEmpty(value)
}


